<div class="content pos-relative flex flex-col" style="height: auto">

  <div class="keno-grid-container">
    <particle-virtual-grid [sourceKey]="sourceKey"
                           [invalidateSubject]="invalidateSubject"
                           (valueChanged)="onGridCellValueChange($event)"
                           [sortEnabled]="true"
                           sortFieldKey="CountryName1"
                           sortDirection="desc">
    </particle-virtual-grid>
  </div>

</div>
